import React, {useEffect, useState} from 'react';
import MicrolessonsLibraryUI from '../view/MicrolessonsLibraryUI';
import {inject, observer} from 'mobx-react';
import MicrolessonsLibraryStore from '../store/MicrolessonsLibraryStore';
import {useNavigate, useParams} from 'react-router-dom';
import {Microlesson} from '../../../data/models/Microlessons/Microlesson';

interface Props {
  microlessonsLibraryStore?: MicrolessonsLibraryStore;
}

export const ITEMS_PER_PAGE = 9;

const MicrolessonsLibraryContainer = inject('microlessonsLibraryStore')(
  observer(({microlessonsLibraryStore}: Props) => {
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [lessons, setLessons] = useState<Microlesson[]>([]);
    const [pagesCount, setPagesCount] = useState(0);

    const navigate = useNavigate();
    const {organizationId, courseId, folderId} = useParams();

    useEffect(() => {
      setSearch('');
      setCurrentPage(1);
      if (organizationId && microlessonsLibraryStore!.showLibrary) {
        microlessonsLibraryStore!
          .getMicrolessonsLibrary(organizationId, 0, ITEMS_PER_PAGE, '')
          .then(res => {
            setLessons(res.data);
            setPagesCount(res.pagesCount);
          });
      }
    }, [microlessonsLibraryStore!.showLibrary]);

    useEffect(() => {
      fetchLessons();
    }, [currentPage]);

    useEffect(() => {
      setCurrentPage(1);
      fetchLessons();
    }, [search]);

    const fetchLessons = () => {
      if (organizationId) {
        microlessonsLibraryStore!
          .getMicrolessonsLibrary(
            organizationId,
            currentPage - 1,
            ITEMS_PER_PAGE,
            search,
          )
          .then(res => {
            setLessons(res.data);
            setPagesCount(res.pagesCount);
          });
      }
    };

    const onCancel = () => {
      microlessonsLibraryStore!.closeLibrary();
    };

    const onSelectLesson = (microlesson: Microlesson) => {
      if (courseId && organizationId && folderId) {
        microlessonsLibraryStore!.copyMicrolessonToCourse(
          organizationId,
          courseId,
          folderId,
          microlesson.id,
        );
      }
    };

    const onCreateLesson = () => {
      onCancel();
      navigate(`/manage/${organizationId}/microlessons`);
    };

    return microlessonsLibraryStore?.showLibrary ? (
      <MicrolessonsLibraryUI
        search={search}
        setSearch={setSearch}
        onCancel={onCancel}
        lessons={lessons}
        currentPage={currentPage}
        pages={pagesCount}
        onPageChange={setCurrentPage}
        onCreateLesson={onCreateLesson}
        onSelectLesson={onSelectLesson}
        isLoading={microlessonsLibraryStore!.isLoading}
      />
    ) : null;
  }),
);

export default MicrolessonsLibraryContainer;
